// extracted by mini-css-extract-plugin
export default {"pulsingFloat":"NextViewButton_pulsingFloat__FYIdK","pulse":"NextViewButton_pulse__nS1fi"};